import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  flatList: {
    marginTop: indent * 0.75,
    width: '100%' as const,
  },
  conentContainer: {
    display: 'flex',
    width: '100%' as const,
  },
});
